class PowerUserMenu {
    constructor() {
        this.modal = document.getElementById('poweruser-menu');
        this.closeButton = this.modal.querySelector('.close');
        this.input = document.getElementById('poweruser-input');
        this.listItems = Array.from(this.modal.querySelectorAll('.poweruser-menu--list > li'));
        this.visibleItems = [...this.listItems];

        this.modalContent = this.modal.querySelector('.modal-content');
        this.box = this.modal.querySelector('.poweruser-menu--box');

        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.keyPressListener = this.keyPressListener.bind(this);
        this.filterItems = this.filterItems.bind(this);
        this.globalShortcutListener = this.globalShortcutListener.bind(this);
        this.navigateItems = this.navigateItems.bind(this);
        this.selectedIndex = 0;

        this.closeButton.addEventListener('click', this.closeMenu);
        this.input.addEventListener('input', this.filterItems);
        document.addEventListener('keydown', this.keyPressListener);
        document.addEventListener('keydown', this.globalShortcutListener);
        document.addEventListener('keydown', this.navigateItems);

        this.modalContent.addEventListener('click', (event) => {
            if(event.target === this.modalContent) {
                this.closeMenu();
            }
        });
    }

    openMenu() {
        this.modal.classList.add('in');
        setTimeout(() => this.input.focus(), 150);
    }

    closeMenu() {
        this.modal.classList.remove('in');
    }

    keyPressListener(e) {
        // console.log(e);
        if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
            this.openMenu();
        } else if (e.key === 'Escape') {
            this.closeMenu();
        }
    }

    filterItems() {
        const filterText = this.input.value.toLowerCase();
        this.selectedIndex = 0;
        this.visibleItems = [];

        this.listItems.forEach((li, index) => {
            const command = li.getAttribute('data-command').toLowerCase();
            if (command.includes(filterText)) {
                li.classList.remove('hidden');
                this.visibleItems.push(li);
                if(index === this.selectedIndex) {
                    li.classList.add('selected');
                }
            } else {
                li.classList.remove('selected');
                li.classList.add('hidden');
            }
        });
    }

    globalShortcutListener(e) {
        if (e.metaKey) {
            let pressedKey = e.key.toLowerCase();
            if (e.shiftKey && e.ctrlKey) {
                pressedKey = 'shift+ctrl+' + pressedKey;
            } else if (e.shiftKey) {
                pressedKey = 'shift+' + pressedKey;
            } else if (e.ctrlKey) {
                pressedKey = 'ctrl+' + pressedKey;
            }
            const matchingItem = this.listItems.find(li => li.getAttribute('data-shortcut') === pressedKey);
            if (matchingItem) {
                e.preventDefault();
                window.open(matchingItem.querySelector('a').href, '_self');
            }
        }
    }


    navigateItems(e) {
        if (this.modal.classList.contains('in')) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                if (e.key === 'ArrowDown') {
                    if (document.activeElement === this.input) {
                        // If the input is focused, just select the first visible item.
                        this.input.blur(); // remove focus from the input
                        this.selectedIndex = 0;
                    } else {
                        this.selectedIndex = Math.min(this.selectedIndex + 1, this.visibleItems.length - 1);
                    }
                } else if (e.key === 'ArrowUp') {
                    if (this.selectedIndex === 0) {
                        // If the first item is selected, focus the input and deselect all items.
                        this.input.focus();
                        this.selectedIndex = -1;
                    } else {
                        this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
                    }
                }
                this.updateSelected();
            } else if (e.key === 'Enter') {
                if (this.selectedIndex !== -1) {
                    window.open(this.visibleItems[this.selectedIndex].querySelector('a').href, '_self');
                }
            }
        }
    }

    updateSelected() {
        this.visibleItems.forEach((li, index) => {
            li.classList.toggle('selected', index === this.selectedIndex);
        });

        if (this.selectedIndex !== -1) {
            this.visibleItems[this.selectedIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }
}

export default PowerUserMenu;
